import {
  ExpirationLogic,
  ReportLabelInspectionArea,
} from '@ulysses-inc/harami_api_client'

/**
 * テキストマッチングの正解値を取得するヘルパー関数
 * 消費期限 ✖️ 未来検査の場合は「~」を付与することで、範囲指定を表現する
 */
export const getMatchingValue = (area: ReportLabelInspectionArea) => {
  if (
    area.type === 'expiration' &&
    (area.expirationLogic === ExpirationLogic.FUTURE_BASED_ON_INSPECTION_TIME ||
      area.expirationLogic === ExpirationLogic.FUTURE_BASED_ON_SELECTED_TIME)
  ) {
    return `${area.matchingValue}~`
  }

  return area.matchingValue
}
